export default function ModuleHeadLine(props) {
  const { className = "" } = props;

  return (
    <>
      <div className={className}>
        <div className="border-top-2 border-main"></div>
        <div
          className="border-top-3 border-main"
          style={{ marginTop: "2px", marginBottom: "2px" }}
        ></div>
        <div className="border-top-2 border-main"></div>
      </div>
    </>
  );
}
